import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiBox, FiLayers, FiImage, FiInbox } from 'react-icons/fi';
import { getProducts, getServices, getBanners, getQueries } from '../../api';

export default function Dashboard() {
  const [stats, setStats] = useState({ products: 0, services: 0, banners: 0, queries: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    Promise.all([getProducts(), getServices(), getBanners(), getQueries()])
      .then(([p, s, b, q]) => {
        setStats({ products: p.length, services: s.length, banners: b.length, queries: q.length });
        setRecent(q.slice(0, 5));
      })
      .catch(() => {});
  }, []);

  const cards = [
    { label: 'Products', value: stats.products, icon: <FiBox />, to: '/admin/products' },
    { label: 'Services', value: stats.services, icon: <FiLayers />, to: '/admin/services' },
    { label: 'Banners', value: stats.banners, icon: <FiImage />, to: '/admin/banners' },
    { label: 'Enquiries', value: stats.queries, icon: <FiInbox />, to: '/admin/queries' },
  ];

  return (
    <div>
      <div className="acontent__head">
        <h1>Dashboard</h1>
        <Link to="/admin/products/new" className="btn btn-primary btn-sm">+ Add Product</Link>
      </div>

      <div className="stat-grid">
        {cards.map((c, i) => (
          <motion.div key={c.label} initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}>
            <Link to={c.to} className="stat" style={{ display: 'block' }}>
              <span className="stat__icon">{c.icon}</span>
              <div className="stat__label">{c.label}</div>
              <div className="stat__value">{c.value}</div>
            </Link>
          </motion.div>
        ))}
      </div>

      <div className="acard">
        <h3>Recent enquiries</h3>
        {recent.length ? (
          <div className="table-wrap">
            <table className="atable">
              <thead><tr><th>Name</th><th>Source</th><th>Message</th><th>Status</th></tr></thead>
              <tbody>
                {recent.map((q) => (
                  <tr key={q._id}>
                    <td>{q.name || q.data?.name || '—'}</td>
                    <td><span className="badge">{q.source}</span></td>
                    <td style={{ maxWidth: 320, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{q.message || '—'}</td>
                    <td><span className={`pill ${q.status}`}>{q.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="muted">No enquiries yet.</p>
        )}
      </div>
    </div>
  );
}
